import { SubscriptionDuration } from "@shared/types";

export const PRIMARY_API_HELPER_ARTICLE_ID = "5814837";
export const PRIMARY_API_HELPER_DESCRIPTION =
  "Each distinct API Key used (can be used for more than 1 account from the same exchange)";

export const CANCEL_AUTO_RENEWAL_SURVEY_ID = "32097368";

export const SUBSCRIPTION_QUERY_PARAMS = {
  DURATION: "duration",
  PLAN: "plan",
  PAYMENT_METHOD: "payment-method",
  STEP: "step",
  IS_ALL_PLANS: "all-plans",
  IS_UPGRADE: "is-upgrade",
} as const;

export const DURATION_TO_SECONDARY_DISPLAY: Record<
  SubscriptionDuration,
  string
> = {
  [30]: "Monthly",
  [360]: "Annually",
};

export const DURATION_TO_PRIMARY_DISPLAY: Record<SubscriptionDuration, string> =
  {
    [30]: "Month",
    [360]: "Annual",
  };

export const TRADES_MISSED_HELPER =
  "Trades that couldn't open because your active signals trades quota was already reached when the signal was published";
export const PAYPAL_PAYMENT_OPTION = "PayPal";
